import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { GestionBaseDatos } from "@/components/configuracion/GestionBaseDatos";

const ConfiguracionBaseDatos = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card/95 backdrop-blur-md shadow-sm">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/configuraciones')}
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Volver
            </Button>
            <div>
              <h1 className="text-2xl font-bold text-foreground">Gestión de Base de Datos</h1>
              <p className="text-sm text-muted-foreground">
                Monitoreo y administración de la base de datos del sistema
              </p>
            </div>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-6 py-8">
        <GestionBaseDatos />
      </main>
    </div>
  );
};

export default ConfiguracionBaseDatos;
